import { z } from 'zod';

import {
  ModalSessionFlightSearchReuseSchema,
  ModalSessionHotelSearchRequestSchema,
} from './session';

/**
 * Escopo MICE da busca de voo (evento corporativo): o viajante é resolvido no
 * grupo corporativo (`isMice` + `corporateGroupId` no token) e, com
 * `requesterClientId`, o solicitante no cliente de origem dele (ex.: a VOLL, 217).
 * Só o mice-api o envia, por M2M — o BFF do navegador não o aceita.
 */
export const ModalSessionFlightMiceScopeSchema = z
  .object({
    corporateGroupId: z.string().min(1),
    requesterClientId: z.string().regex(/^\d+$/).optional(),
  })
  .strict();
export type ModalSessionFlightMiceScope = z.infer<typeof ModalSessionFlightMiceScopeSchema>;

/** O pedido de busca de voo em si — sem identidade. Nomeado porque o refine o lê
 *  de volta do `search` persistido na sessão (mesma rota, mesmo searchKey). */
export const ModalSessionFlightSearchInputSchema = z
  .object({
    origin: z.string().min(1),
    destination: z.string().min(1),
    departureDate: z.iso.date(),
    returnDate: z.iso.date().optional(),
    cabin: z.enum(['economy', 'premium', 'business', 'first']).optional(),
    // Policy subject: the traveler whose corporate compliance governs the
    // within-policy verdict. Distinct from the requester (`userId`). Mirrors
    // hotel search's `travelerId`. Absent ⇒ the verdict falls back to the
    // requester downstream (voll-apollo `travelersId`).
    policyTravelerId: z.string().min(1).optional(),
    miceScope: ModalSessionFlightMiceScopeSchema.optional(),
  })
  .strict();
export type ModalSessionFlightSearchInput = z.infer<typeof ModalSessionFlightSearchInputSchema>;

export const ModalSessionFlightSearchRequestSchema = z
  .object({
    clientId: z.string().min(1),
    userId: z.string().min(1),
    search: ModalSessionFlightSearchInputSchema,
    reuseSearchFrom: ModalSessionFlightSearchReuseSchema.optional(),
  })
  .strict();
export type ModalSessionFlightSearchRequest = z.infer<typeof ModalSessionFlightSearchRequestSchema>;

export const ModalSessionProductSearchRequestSchema = z.union([
  ModalSessionFlightSearchRequestSchema,
  ModalSessionHotelSearchRequestSchema,
]);
export type ModalSessionProductSearchRequest = z.infer<
  typeof ModalSessionProductSearchRequestSchema
>;
